import { useNavigate } from 'react-router-dom'

import { AppRoutes } from '@/constants/appRoutes'
import { findSsoProvider, type SsoProviderId } from '@/constants/ssoProviders'
import Env from '@/env/env'
import { finalSession, sessionSchema } from '@/features/security/securityClient'
import { useAppDispatch } from '@/hooks/redux'
import { api } from '@/store/api'
import { setSession } from '@/store/api/Auth/Auth.slice'
import { setUserCredentials } from '@/store/api/SignUp/SignUp.slice'

export interface SsoPendingInviteState {
  ssoNonce: string
  email: string
  firstName: string
  lastName: string
}

export const useSSO = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const startSSO = (providerId: SsoProviderId, inviteToken?: string) => {
    const provider = findSsoProvider(providerId)
    if (!provider) return
    const path = inviteToken
      ? provider.backendInvitePath(inviteToken)
      : provider.backendInitPath
    window.location.href = `${Env.REACT_APP_BASE_API_URL}${path}`
  }

  const successSSO = (token: string, status: string, email: string) => {
    const session = sessionSchema.safeParse({ token, userStatus: status })
    if (!session.success) {
      navigate(AppRoutes.login)
      return
    }
    dispatch(api.util.resetApiState())
    dispatch(setSession(finalSession(session.data)))

    if (status === 'pending_on_boarding') {
      dispatch(setUserCredentials({ email, authToken: token }))
      navigate(AppRoutes.registerFirstStep)
      return
    }

    if (status === 'active') {
      navigate(AppRoutes.dashboard)
      return
    }

    navigate(AppRoutes.login)
  }

  const continueSsoInvite = (state: SsoPendingInviteState) => {
    navigate(AppRoutes.inviteSecondStep, { state })
  }

  return { startSSO, successSSO, continueSsoInvite }
}
